import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { goatLogo } from '../assets/images'

export default function Nav() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', h, { passive: true })
    return () => window.removeEventListener('scroll', h)
  }, [])

  useEffect(() => setOpen(false), [location.pathname])

  const goHome = () => { navigate('/'); window.scrollTo({ top: 0, behavior: 'instant' }) }
  const goMenu = () => { navigate('/menu'); window.scrollTo({ top: 0, behavior: 'instant' }); setOpen(false) }

  const scrollTo = (id) => {
    setOpen(false)
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } })
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
      <button className="nav-logo" onClick={goHome}>
        <img className="nav-logo-mark" src={goatLogo} alt="" />
        GOAT
      </button>

      <ul className={`nav-links${open ? ' open' : ''}`}>
        <li><button onClick={() => scrollTo('about')}>About</button></li>
        <li><button onClick={() => scrollTo('featured')}>Featured</button></li>
        <li><button onClick={() => scrollTo('visit')}>Visit</button></li>
        <li><button onClick={() => scrollTo('reserve')}>Contact</button></li>
        <li><button className="nav-menu-btn" onClick={goMenu}>See Menu</button></li>
      </ul>

      <button
        className={`nav-hamburger${open ? ' open' : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle navigation"
        aria-expanded={open}
      >
        <span /><span /><span />
      </button>
    </nav>
  )
}
